(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products-alternate"] && !Shopify.designMode) return;
  try {
    class CartLineItem extends HTMLElement {
    #boundHandler = () => {
      requestAnimationFrame(() => this.enforceInventoryLimit());
    };

    connectedCallback() {
      this.enforceInventoryLimit();
      document.addEventListener('cart:update', this.#boundHandler);

      // Prevent remove button click from bubbling to the dialog click-outside handler
      var removeButton = this.querySelector('.cart-products-alt__remove');
      if (removeButton) {
        removeButton.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.#boundHandler);
    }

    enforceInventoryLimit() {
      var maxQuantity = parseInt(this.dataset.maxQuantity, 10);
      if (isNaN(maxQuantity) || maxQuantity <= 0) return;

      var input = this.querySelector('cart-quantity-selector-component input[type="number"]');
      if (!input) return;

      input.setAttribute('max', maxQuantity);

      var currentValue = parseInt(input.value, 10);
      if (currentValue > maxQuantity) {
        input.value = maxQuantity;
      }

      var component = this.querySelector('cart-quantity-selector-component');
      if (component && typeof component.updateButtonStates === 'function') {
        component.updateButtonStates();
      }
    }
  }

  if (!customElements.get('cart-line-item')) {
    customElements.define('cart-line-item', CartLineItem);
  }

  // Patch onLineItemRemove on cart-items-component instances to find rows by
  // data-line attribute instead of array index. Needed because vendor grouping
  // means DOM order ≠ cart line order. See comment on <cart-line-item> above.
  customElements.whenDefined('cart-items-component').then(() => {
    for (const component of document.querySelectorAll('cart-items-component')) {
      const original = component.onLineItemRemove.bind(component);
      component.onLineItemRemove = function (line) {
        // Swap the row at [line - 1] with the correct one before calling original
        const rows = this.refs.cartItemRows;
        if (!rows) {
          original(line);
          return;
        }
        const targetIndex = line - 1;
        const correctRow = rows.find((row) => row.dataset.line === String(line));
        if (correctRow && rows[targetIndex] !== correctRow) {
          const wrongIndex = rows.indexOf(correctRow);
          [rows[targetIndex], rows[wrongIndex]] = [rows[wrongIndex], rows[targetIndex]];
        }
        original(line);
      };
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["operation-card"] && !Shopify.designMode) return;
  try {
    // Sets --card-height on small cards (< 240px) so CSS can cap
  // the logo height as a fraction of the card.
  class OperationLogo extends HTMLElement {
    static observer = null;
    static observedCards = new WeakSet();

    connectedCallback() {
      OperationLogo.observeCard(this);
    }

    static observeCard(instance) {
      const card = instance.closest('.operation-card');
      if (!card || OperationLogo.observedCards.has(card)) return;
      OperationLogo.observedCards.add(card);
      if (!OperationLogo.observer) {
        OperationLogo.observer = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const h = entry.contentBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
            const logo = entry.target.querySelector('.operation-card__logo');
            if (!logo) return;
            if (h < 240) {
              logo.style.setProperty('--card-height', `${h}px`);
            } else {
              logo.style.removeProperty('--card-height');
            }
          }
        });
      }
      OperationLogo.observer.observe(card);
    }
  }

  if (!customElements.get('operation-logo')) {
    customElements.define('operation-logo', OperationLogo);
  }
  } catch(e) { console.error(e); }
})();

})();
